<template>
    <Layout>
        <div class="container m_height">
            <!-- <div class="d-flex justify-content-center align-items-center mt-5">
                <div class="session_box alert alert-warning">
                    <span class="fa fa-warning fa-fw"></span>
                    Your Session will expire in <strong> 17 Minutes!</strong>
                </div>
            </div> -->

            <div class="registration_steps text-justify">
                <h1 class="cl_gr text-uppercase my-3">Reset password</h1>
                <p>
                    To Reset your password, please enter your username then click the <span class="cl_gr">"RESET"</span> button.
                </p>
                <p>
                    You will recieve email with your reset password Link.
                </p>
            </div>
            <form class="register_form" @submit="resetPasswordRequestSubmitted">
                <div class="alert alert-danger" v-if="errorMsg != ''">
                     {{ errorMsg }}
                </div>
                <div class="alert alert-success" v-if="successMsg != ''">
                     {{ successMsg }}
                </div>

                <div class="form-group required">
                    <div class="row">
                        <div :class="{ 'has-error': $v.username.$error, 'col-sm-12':true }">
                            <label for="username">Username</label>
                            <input v-model="username" name="username" type="text" class="form-control" id="username">
                            <small class="text-danger" v-if="!$v.username.required">Field is required</small>
                        </div>
                    </div>
                </div>
              <button type="submit" class="btn btn-success mt-3">Reset</button>
              <a href="/auth/login" type="submit" class="btn btn-danger mt-3 ml-3">Login</a>

            </form>
        </div>



    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required } from 'vuelidate/lib/validators'
import Api from '@/Api'

export default {
    name: 'EmailPassword',
    components: {Layout},
    data() {
        return {
            username:'',
            errorMsg:'',
            successMsg:'',
        };
    },
    validations: {
        username: {required}
    },
    methods: {
        resetPasswordRequestSubmitted: function(e){
            e.preventDefault();
            if (this.$v.$invalid)
                return;
            var scope = this;
            this.errorMsg = '';
            this.successMsg = '';
            let data = {
              name: this.username
            };
            Api().post(`auth/password/email` , data)
                .then(res => {
                    this.successMsg = res.data.message
                    this.username = '';
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            scope.errorMsg = err.errors[0].message;
                        }
                    }
                });
        }
    }
};
</script>
